import { render } from "./resale-category-badge.vue?vue&type=template&id=51daca96&ts=true"
import script from "./resale-category-badge.vue?vue&type=script&lang=ts"
export * from "./resale-category-badge.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__